module.exports = __webpack_public_path__ + "static/media/Animals.c4c0bb82.mp3";